import React from 'react';
import { motion } from 'framer-motion';
interface SlideProps {
  index: number;
  total: number;
}
export function Slide1ExecSummary({
  index
}: SlideProps) {
  return <div className="relative w-screen h-screen overflow-hidden bg-black" data-id="element-110">
      {/* Hero video with cinematic overlay */}
      <div className="absolute inset-0" data-id="element-111">
        <motion.video src="https://cdn.magicpatterns.com/uploads/dtrapZyKnwoTug4Qz98A7w/anzup.mp4" autoPlay loop muted playsInline className="w-full h-full object-cover opacity-90" initial={{
        scale: 1.08
      }} animate={{
        scale: 1
      }} transition={{
        duration: 8,
        ease: 'easeOut'
      }} data-id="element-112" />
        <div className="absolute inset-0 bg-gradient-to-r from-black/80 via-black/40 to-transparent" data-id="element-113" />
        <div className="absolute inset-0 bg-gradient-to-t from-black/80 via-transparent to-transparent" data-id="element-114" />
      </div>

      {/* Thin brand rule top */}
      <motion.div initial={{
      scaleX: 0
    }} animate={{
      scaleX: 1
    }} transition={{
      delay: 0.1,
      duration: 0.8,
      ease: 'easeOut'
    }} className="absolute top-0 left-0 right-0 h-1 bg-[var(--brand-green)] origin-left z-20" data-id="element-115" />

      {/* Content */}
      <div className="relative z-10 h-full flex flex-col justify-center px-[clamp(2rem,6vw,6rem)] pb-[clamp(5rem,9vh,7rem)] pt-[clamp(2rem,4vw,4rem)]" data-id="element-116">
        <div className="max-w-5xl" data-id="element-117">
          {/* Eyebrow */}
          <motion.div initial={{
          opacity: 0,
          y: 16
        }} animate={{
          opacity: 1,
          y: 0
        }} transition={{
          delay: 0.25,
          duration: 0.6
        }} className="flex items-center gap-4 mb-[clamp(1.25rem,2.5vw,2rem)]" data-id="element-118">
            <span className="h-px w-10 bg-[var(--brand-green-lighter)]" data-id="element-119" />
            <p className="text-[var(--brand-green-lighter)] text-[clamp(0.85rem,1.3vw,1.1rem)] font-semibold uppercase tracking-[0.25em]" data-id="element-120">
              SNAKKER PROPOSAL&nbsp;&nbsp;|&nbsp;&nbsp;LEO Pharma UK
            </p>
          </motion.div>

          {/* Headline */}
          <motion.h1 initial={{
          opacity: 0,
          y: 24
        }} animate={{
          opacity: 1,
          y: 0
        }} transition={{
          delay: 0.4,
          duration: 0.7
        }} className="text-white font-bold text-[clamp(2.75rem,5.5vw,5rem)] leading-[1.05] tracking-tight mb-[clamp(1.25rem,2.5vw,2rem)]" data-id="element-121">
            Not more traffic.
            <br data-id="element-122" />
            <span className="text-[var(--brand-green-lighter)]" data-id="element-123">
              Better-qualified engagement.
            </span>
          </motion.h1>

          {/* Subline */}
          <motion.div initial={{
          opacity: 0,
          y: 20
        }} animate={{
          opacity: 1,
          y: 0
        }} transition={{
          delay: 0.55,
          duration: 0.6
        }} className="space-y-4 max-w-3xl" data-id="element-124">
            <p className="text-white/90 text-[clamp(1.1rem,1.4vw,1.3rem)] font-medium leading-relaxed" data-id="element-125">
              Anzupgo already has digital visibility, with 144k Google
              impressions and 16k DERMAWorld page views. However, the funnel
              suggests that this visibility is not yet translating into enough
              meaningful engagement, with only 232 unique DERMAWorld visitors.
            </p>
            <p className="text-white/90 text-[clamp(1.1rem,1.4vw,1.3rem)] font-medium leading-relaxed" data-id="element-126">
              The opportunity is not simply to drive more traffic. The
              opportunity is to improve the quality of engagement.
            </p>
            <p className="text-[var(--brand-green-lighter)] text-[clamp(1.1rem,1.4vw,1.3rem)] font-bold leading-relaxed pt-2" data-id="element-127">
              Snakker turns Anzupgo visibility into focused, easy-to-digest HCP
              journeys.
            </p>
          </motion.div>
        </div>
      </div>
    </div>;
}